import { apiHelper } from '../utils/apiHelper';

const API_URL = `${process.env.REACT_APP_API_URL}/api/admin/seo`;

export const fetchSeoContents = (payload) => apiHelper(API_URL, 'GET', payload);
export const updateSeoContents = (payload) => apiHelper(`${process.env.REACT_APP_API_URL}/api/admin/update-seo-data`, 'POST', payload);